export default __webpack_public_path__ + "64b376634e15db280d8903a4b43010af.jpg";